import React from "react";
import "./price.scss";
import redCheck from "./redCheck.png";
import redCross from "./redCross.png";
import greenCheck from "./greenCheck.png";


const Price  = ({
                    openMembershipPage,
                }: {
    openMembershipPage: (id:any) => void;
}) => {
    const handleSignUp = (id:any) => {
        console.log('Sign Up clicked for ID:', id);
        openMembershipPage(id);
    };

    return (
        <div className="purchaseMembershipWrapper">
            <div className="price" id="purchaseMembership">
                <div className="preferencesLeft">
                    <h3 className="preferencesTitle">
                        This membership <br/> <span>is for you if you want...</span>
                    </h3>
                    <ol>
                        <li><span className='strong'>Certainty:</span> Knowing there's a reliable source to turn to during pregnancy and parenting.</li>
                        <li><span className='strong'>Security:</span> Feeling supported by professionals who understand your journey.</li>
                        <li><span className='strong'>A Better Future:</span> Gaining confidence in parenting decisions, leading to a happier family life.</li>
                    </ol>
                </div>

                <div className="preferencesRight">
                    <div className="annuallyPreference">
                        <div className="greenHeader">
                            <p><span>Annual </span> Membership</p>
                        </div>
                        <div className="bestPrice">
                            <p>Best Price!</p>
                        </div>
                        <div className="container">
                            <p className="priceText"><span className="crossedPrice">$149</span><span className="strong">$83</span>/mo</p>
                            <p className="priceDescription"><span>$999</span> annually, cancel any time.</p>
                            <button
                                className="btn-small teal-btn-small w-fit"
                                onClick={()=>handleSignUp(2)}
                            >
                                Sign Up
                            </button>
                            {membershipPreferenceList.map((item) => (
                                <div key={item.id} className="description">
                                    <img src={greenCheck} alt={item.description} />
                                    <p className={"boldText"}>{item.description}</p>
                                </div>
                            ))}
                        </div>
                        <button
                            className="btn-small teal-btn-small mobileOnly"
                            onClick={()=>handleSignUp(2)}
                        >
                            Sign Up
                        </button>
                    </div>

                    <div className="monthlyPreference">
                        <div className="redHeader">
                            <p><span>Monthly </span> Membership</p>
                        </div>
                        <div className="container">
                            <p className="priceText"><span className="strong">$149</span>/mo</p>
                            <p className="priceDescription">Renews monthly, cancel any time.</p>
                            <button
                                className="btn-small pink-btn-small w-fit"
                                onClick={()=>handleSignUp(1)}
                            >
                                Sign Up
                            </button>
                            {membershipPreferenceList.map((item) => (
                                <div key={item.id} className="description">
                                    <img src={item.id < membershipPreferenceList?.length - 7 ? redCheck : redCross} alt={item.description} />
                                    <p className={item.id >= membershipPreferenceList?.length - 7 ? "grayText" : "text"}>{item.description}</p>
                                </div>
                            ))}
                        </div>
                        <button
                            className="btn-small pink-btn-small mobileOnly"
                            onClick={()=>handleSignUp(1)}
                        >
                            Sign Up
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const membershipPreferenceList = [
    {
      id: 0,
      description:
          "24/7 Ask a Nurse Message Board",
    },
    {
      id: 1,
      description:
          "Weekly, virtual Q&As with a Registered Nurse",
    },
    {
      id: 2,
      description:
          "On demand video content library",
    },
    {
      id: 3,
      description:
          "Prenatal and parenting Workshops",
    },
    {
      id: 4,
      description:
          "A supportive community of parents and professionals",
    },
    {
      id: 5,
      description:
          "Bootcamps",
    },
    {
      id: 6,
      description:
          "Monthly prenatal and parenting classes",
    },
    {
      id: 7,
      description:
          "Infant and Child CPR with First Aid course",
    },
    {
      id: 8,
      description:
          "Peer Support Groups",
    },
    {
      id: 9,
      description:
          "Sleep Consultation",
    },
    {
      id: 10,
      description:
          "1:1 Telehealth Feeding Consultation",
    },
    {
      id: 11,
      description:
          "Two, 1:1 calls with a Registered Nurse or Nurse Practitioner",
    },
]


export default Price;
